export default __webpack_public_path__ + "static/three-1aa121e4ae6b9c846744ecdeda0ab377.png";